import { render, staticRenderFns } from "./OrderViewActionsManager.vue?vue&type=template&id=7543c0b6&"
import script from "./OrderViewActionsManager.vue?vue&type=script&lang=js&"
export * from "./OrderViewActionsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports